import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default {
  namespaced: true,
  state: {
    cliente: null,
    saved: false,
    refresh: false,
    creaClifor: false,
    editClifor: false,
    cliforCreato: null
  },
  getters: {
    cliente: state => state.cliente,
    saved: state => state.saved,
    refresh: state => state.refresh,
    creaClifor: state => state.creaClifor,
    editClifor: state => state.editClifor,
    cliforCreato: state => state.cliforCreato
  },
  mutations: {
    SET_CLIENTE (state, payload) {
      state.cliente = payload
    },
    CLEAR_CLIENTE (state) {
      state.cliente = null
    },
    SET_CLIENTE_SAVED (state) {
      state.saved = true
    },
    CLEAR_CLIENTE_SAVED (state) {
      state.saved = false
    },
    SET_REFRESH (state) {
      state.refresh = true
    },
    CLEAR_REFRESH (state) {
      state.refresh = false
    },
    SET_CREA_CLIFOR(state) {
      state.creaClifor = true
    },
    CLEAR_CREA_CLIFOR(state) {
      state.creaClifor = false
    },
    SET_CLIFOR_CREATO(state, payload) {
      state.cliforCreato = payload
    },
    SET_EDIT_CLIFOR(state) {
      state.editClifor = true
    },
    CLEAR_EDIT_CLIFOR(state) {
      state.editClifor = false
    }
  },
  actions: {
  }
}
